/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Duration_TitleInputs */



/**
* | output |
* | --- |
* | "Event duration is invalid" |
*
* @param {Event_Warning_Duration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_duration_title = /** @type {((inputs?: Event_Warning_Duration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Duration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée d'événement invalide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisdauer ist ungültig.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La durata dell'evento non è valida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность события недопустима.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La duración del evento no es válida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件持续时间无效")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント期間が無効です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की अवधि अमान्य है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A duração do evento é inválida.")
	return /** @type {LocalizedString} */ ("Event duration is invalid")
});